<div class="sidebar-outer">
    <a class="logo d-flex align-items-center" 
       routerLink="/" (click)="closeSubMenus()" 
       *ngIf="appSettings.settings2.panel.sidebarIsFixed">
        <span class="start">{{appSettings.settings2.panel.headerTitle}}</span><span class="ng"></span>        
    </a>
    <lib-shared-vertical-menu></lib-shared-vertical-menu>   
</div>